import { ModalSizes } from "components/atoms/Modal";
import { modals } from "./modalSlice.types";

export const IModalComponents: {
  [key in modals]: {
    defaultSize: ModalSizes;
    closeOnOverlayClick?: boolean;
    showBackdrop?: boolean;
  };
} = {
  confirmCancelShipment: {
    defaultSize: "sm",
  },
  confirmUncancelShipment: {
    defaultSize: "sm",
  },
  confirmCancelPickup: {
    defaultSize: "sm",
  },
  createBulkShipment: {
    defaultSize: "sm",
    closeOnOverlayClick: false,
  },
  pickUpRequestModal: {
    defaultSize: "sm",
    closeOnOverlayClick: false,
  },
  createShipment: {
    defaultSize: "2xl",
    closeOnOverlayClick: false,
  },
  createQuotePalletSwitchWarningModal: {
    defaultSize: "xs",
  },
  createQuoteGirthWarningModal: {
    defaultSize: "xs",
  },
  createBulkShipmentProfile: {
    defaultSize: "md",
  },
  createSingleLabel: {
    defaultSize: "sm",
    closeOnOverlayClick: false,
  },
  selectReceiverAddress: {
    defaultSize: "sm",
  },
  selectReceiverPickupPoint: {
    defaultSize: "3xl",
  },
  selectSenderAddress: {
    defaultSize: "sm",
  },
  editBulkShipmentProfile: {
    defaultSize: "md",
  },
  labels: {
    defaultSize: "sm",
    closeOnOverlayClick: false,
  },
  confirmCloseCreateShipmentModal: {
    defaultSize: "sm",
  },
  confirmBulkDeleteShipmentsModal: {
    defaultSize: "sm",
  },
  confirmBulkDeleteAddressesModal: {
    defaultSize: "sm",
  },
  confirmRefetchShipmentRates: {
    defaultSize: "sm",
  },
  confirmDeleteShipmentProfile: {
    defaultSize: "sm",
  },
  confirmRerunRulesModal: {
    defaultSize: "sm",
  },
  createRule: { defaultSize: "md-wide" },
  createReceiverAddress: {
    defaultSize: "xl",
  },
  createCompanyAddress: {
    defaultSize: "xl",
  },
  editRule: { defaultSize: "md-wide" },
  customerOnStopWarning: {
    defaultSize: "sm",
  },
  viewShipment: { defaultSize: "md", showBackdrop: false },
  viewCase: { defaultSize: "md", showBackdrop: false },
  exceptionNotifications: { defaultSize: "md" },
  viewQuote: { defaultSize: "lg" },
  shipmentReport: { defaultSize: "md" },
  labelReport: { defaultSize: "md" },
  quoteReport: { defaultSize: "md" },
  helpContactInfo: { defaultSize: "md", closeOnOverlayClick: true },
  pickUpModal: { defaultSize: "full", closeOnOverlayClick: true },
  viewPickupModal: { defaultSize: "lg", showBackdrop: false },
  selectImporterAddress: {
    defaultSize: "sm"
  },
  bulkEditShipmentsModal: {
    defaultSize: "full",
    closeOnOverlayClick: false,
  },
  bulkAddServicesModal: {
    defaultSize: "lg",
    closeOnOverlayClick: false,
  },
  uploadAddresses: {
    defaultSize: "lg",
    closeOnOverlayClick: false,
  },
  surchargeReport: {
    defaultSize: "md",
  },
  scanAndPrint: {
    defaultSize: "2xl",
    closeOnOverlayClick: true,
  },
  podImage: {
    defaultSize: "sm",
    closeOnOverlayClick: true,
  },
  createDemoAccount: {
    defaultSize: "md",
    closeOnOverlayClick: false,
  },
};
